import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { ApiBaseService } from './api-base.service'; 
import { SharedService } from './shared.service';
import { PackageModel, PackageSearchModel } from '@shared/models/PackageModel';
import { Country } from '@shared/models/Enums';


@Injectable()
export class ApiPackageService extends ApiBaseService {

    constructor(public http: HttpClient, public sharedService: SharedService) {
        super(http, sharedService);
    }

    // Package API //


    // POST: api/admin/packages/reads/v1
    getAllPackages(search: PackageSearchModel): Promise<PackageModel[]> {

        return this.http.post(`${this.baseUrl}/api/admin/packages/reads/v1`, search, this.getHttpOptions())
            .toPromise().then(
                (results: any) => {

                    let allPackage = results.map(x => {
                        return new PackageModel(x);
                    })

                    return allPackage;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de los packs: ${errMsg}`));
                }
            );
    }

    // POST: api/admin/packages/reads/v1/{id}
    getPackage(id: number, country?: Country): Promise<PackageModel> {

        return this.http.get(`${this.baseUrl}/api/admin/packages/reads/v1/${id}`, this.getHttpOptions(country))
            .toPromise().then(
                (results: any) => {

                    let fullPackage = new PackageModel(results);

                    return fullPackage;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información del pack: ${errMsg}`));
                }
            );
    }

    // POST: api/admin/packages/reads/v1/{id}
    getNoSessionPackage(id: number, country: Country): Promise<PackageModel> {

        return this.http.get(`${this.baseUrl}/api/admin/packages/reads/v1/${id}`, this.getHttpOptionsWithoutSession(country))
            .toPromise().then(
                (results: any) => {

                    let fullPackage = new PackageModel(results);

                    return fullPackage;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información del pack: ${errMsg}`));
                }
            );
    }

    // POST: api/admin/packages/vendor/reads/v1/{id}
    getAllPackagesByVendor(id: number): Promise<PackageModel[]> {

        return this.http.post(`${this.baseUrl}/api/admin/packages/vendor/reads/v1/${id}`, null, this.getHttpOptions())
            .toPromise().then(
                (results: any) => {

                    let allPackage = results.map(x => {
                        return new PackageModel(x);
                    })

                    return allPackage;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de los packs: ${errMsg}`));
                }
            );
    }

}
